module.exports = __webpack_public_path__ + "img/bowl.8df60db5.svg";